import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import Button2 from "../components/Button2";
import InputText2 from "../components/InputText2";
import { ReactComponent as PhotoIcon } from "../icons/photo.svg";
import { ReactComponent as SuccessIcon } from "../icons/success.svg";
import PDLList from "../components/PDLList";
import Dropdown from "../components/Dropdown";
import { adminServices } from "../services/AdminServices";
import AlertModal from "../components/AlertModal";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import withAuthorization from "../components/withAuthorization";
import { use } from "react";
import { toast } from "react-toastify";
import { encryptSHA256 } from "../tools/tool";
import { validatePassword } from "../tools/passwordPolicy";
import InputText1 from "../components/InputText1";
document.title = 'PDL Administration | Merchant Onboarding';
const MerchantPage_Add = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState('');
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [services, setServices] = useState([]);
  const [newService, setNewService] = useState("");
  const [categories, setCategories] = useState([]);
  const [options, setOptions] = useState([]);
  const [serviceAmount, setServiceAmount] = useState(0);
  const [unit, setUnit] = useState('');
  const [withSf, setWithSf] = useState(1); //1 yes 2 no

  const [fee, setFee] = useState(0);
  const [pdlId, setPDLId] = useState(0);
  const [pdlNumber, setPDLNumber] = useState('0000000000');
  const [firstName, setFirstName] = useState('----------');
  const [middleName, setMiddleName] = useState('----------');
  const [lastName, setLastName] = useState('----------');
  const [gender, setGender] = useState('------');
  const [facilityNumber, setFacilityNumber] = useState('----------');
  const [openPDLList, setOpenPDLList] = useState(false);
  const [merchantId, setMerchantId] = useState(0);
  const [selectedCat, setSelectedCat] = useState(0);
  const [location, setLocation] = useState('');
  const [storeCode, setStoreCode] = useState('');
  const [storeLocation, setStoreLocation] = useState('');
  const [colonies, setColonies] = useState([]);
  const [posUser, setPosUser] = useState('');
  const [posPassword, setPosPassword] = useState('');
  const [quadrant, setQuadrant] = useState(null);
  const [facilities, setFacilities] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [storeCodeValidating, setStoreCodeValidating] = useState(false);
  const [storeCodeExists, setStoreCodeExists] = useState(false);
  const [storeCodeError, setStoreCodeError] = useState('');
  const [merchantType, setMerchantType] = useState('');

  // Function to handle adding a new service to the list

  useEffect(() => {
    getToken();
    getServiceCategories();
    getColonies();
  }, []);

  // Validate storeCode when it changes
  useEffect(() => {
    if (storeCode.trim() === '') {
      setStoreCodeError('');
      setStoreCodeExists(false);
      return;
    }

    // Debounce the validation
    const timer = setTimeout(() => {
      validateStoreCode(storeCode);
    }, 800);
    return () => clearTimeout(timer);
  }, [storeCode]);
  const validateStoreCode = async code => {
    if (!code.trim()) return;
    setStoreCodeValidating(true);
    setStoreCodeError('');
    setStoreCodeExists(false);
    try {
      const response = await fetch('http://10.0.20.254:4345/api/sp/v2/storeCodeExists', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('appToken')}`
        },
        body: JSON.stringify({
          storeCode: code
        })
      });
      const data = await response.json();
      if (response.ok) {
        if (Array.isArray(data) && data.length === 0) {
          setStoreCodeError('');
          setStoreCodeExists(false);
        } else if (Array.isArray(data) && data.length > 0) {
          setStoreCodeError('Store code already exists');
          setStoreCodeExists(true);
        } else {
          setStoreCodeError('');
          setStoreCodeExists(false);
        }
      } else {
        setStoreCodeError('Error validating store code');
      }
    } catch (error) {
      console.error('Store code validation error:', error);
      setStoreCodeError('Unable to validate store code');
    } finally {
      setStoreCodeValidating(false);
    }
  };
  const getColonies = () => {
    adminServices.storeProcedure2('getColonies', {}).then(r => {
      // expecting columns: colony_id, colony_name
      const data = r.data || [];
      const opts = data.map(c => ({
        value: c.colony_id,
        label: c.colony_name,
        fac: JSON.parse(c.facilities || [])
      }));
      var defaultOption = {
        label: '--- Select Store Location ---',
        value: null
      };
      setColonies([defaultOption, ...opts]);
    }).catch(e => {
      //console.log('getColonies error', e);
    });
  };
  useEffect(() => {
    if (storeLocation) {
      const fac = colonies.find(c => c.value == storeLocation)?.fac;
      var defaultOption = {
        Facility: '---Select a facility/quadrant---',
        FacilityId: null
      };

      //console.log(defaultOption, fac);

      setFacilities([defaultOption, ...fac]);
    }
  }, [storeLocation]);
  const getToken = () => {
    setToken(localStorage.getItem('adminServicesToken'));
  };
  const getServiceCategories = () => {
    adminServices.serviceCategories().then(r => {
      let data = r.data.filter(d => {
        return d.statusId == 1;
      });
      //console.log(data);
      let _opt = [];
      _opt.push({
        value: 0,
        label: "--Select Category--"
      });
      for (var i of data) {
        _opt.push({
          value: i.id,
          label: i.category
        });
      }
      setOptions(_opt);
    }).catch(e => {
      //console.log(e);
    });
  };
  const addService = () => {
    if (newService.trim() !== "") {
      setServices([...services, {
        service: newService.trim(),
        amount: serviceAmount,
        unit: unit
      }]);
      setNewService(""); // Clear input after adding
      setServiceAmount(0);
    }
  };
  const registerMerchant = async () => {
    if (submitted == true) {
      return;
    }
    if (pdlId == 0) {
      setAlertMessage("Please select a PDL");
      setShowAlert(true);
      setSubmitted(false);
      return;
    }
    if (merchantType == '') {
      setAlertMessage("Please select a Merchant Type");
      setShowAlert(true);
      setSubmitted(false);
      return;
    }
    if (name == '') {
      setAlertMessage("Please enter a Merchant Name");
      setShowAlert(true);
      setSubmitted(false);
      return;
    }
    if (description == '') {
      setAlertMessage("Please enter a Store Name");
      setShowAlert(true);
      setSubmitted(false);
      return;
    }
    if (location == '') {
      setAlertMessage("Please enter a Location");
      setShowAlert(true);
      setSubmitted(false);
      return;
    }
    if (merchantType == "Services") {
      if (selectedCat == 0) {
        setAlertMessage("Please select a category");
        setShowAlert(true);
        setSubmitted(false);
        return;
      }
    }
    if (merchantType == "Store") {
      if (posUser == "") {
        setAlertMessage("Please enter a Username");
        setShowAlert(true);
        setSubmitted(false);
        return;
      }
      if (posPassword == "") {
        setAlertMessage("Please enter a Password");
        setShowAlert(true);
        setSubmitted(false);
        return;
      }
      const passwordCheck = validatePassword(posPassword);
      if (!passwordCheck.valid) {
        setAlertMessage(passwordCheck.message);
        setShowAlert(true);
        setSubmitted(false);
        return;
      }
      if (storeLocation == "" || storeLocation == null) {
        setAlertMessage("Please select a Store Location");
        setShowAlert(true);
        setSubmitted(false);
        return;
      }
    }
    if (quadrant == "" || quadrant == null) {
      setAlertMessage("Please select a Store Location");
      setShowAlert(true);
      setSubmitted(false);
      return;
    }
    if (storeCodeExists) {
      setAlertMessage("Store code already exists. Please use a different store code.");
      setShowAlert(true);
      setSubmitted(false);
      return;
    }
    var postData = {
      "clientId": pdlId,
      "type": merchantType,
      "merchantName": name,
      "description": description,
      "location": location,
      "merchantCode": storeCode || null,
      "storeLocation": storeLocation || null,
      "categoryId": selectedCat,
      "quadrant": quadrant,
      "withSf": withSf,
      "kioskFee": merchantType == "Services" ? fee : 0,
      "posFee": merchantType == "Store" ? fee : 0,
      "servicesNavigation": [],
      "posUsers": [],
      "outlets": []
    };
    let hashed = encryptSHA256(posPassword);
    if (merchantType == "Store") {
      postData.posUsers.push({
        username: posUser,
        password: hashed
      });
      postData.outlets.push({
        "outletName": name,
        "address": location,
        "merchant": "",
        "contactNo": "-"
      });
      postData.servicesNavigation = [];
      postData.categoryId = null;
    } else {
      services.map(s => {
        var ss = {
          "serviceCatId": selectedCat,
          "service1": s.service,
          "price": s.amount,
          "unit": s.unit,
          "description": "-"
        };
        postData.servicesNavigation.push(ss);
      });
      postData.outlets = [];
      postData.posUsers = [];
    }
    setSubmitted(true);
    await adminServices.registerMerchant(token, postData).then(r => {
      if (r.status == 201) {
        toast.success("Merchant Successfully Added!, please wait while redirecting", {
          autoClose: 1500
        });
        setTimeout(() => {
          window.location.href = "/merchant/edit/" + r.data.id;
        }, 1500);
      }
    }).catch(e => {
      //alert("Error Saving Merchant");
      if (merchantType == "Store") {
        setAlertMessage("POS Username already exists");
      } else {
        setAlertMessage("Error Saving Merchant");
      }
      setShowAlert(true);
      setSubmitted(false);
    });
  };
  const selectPDL = () => {
    setOpenPDLList(true);
  };

  // Function to handle form submission
  const handleSubmit = e => {
    e.preventDefault();
  };

  //modal function
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openSuccessModal = () => {
    if (!submitted) {
      registerMerchant();
    }

    //setModalIsOpen(true);
  };
  const closeSuccessModal = () => {
    setModalIsOpen(false);
    navigate("/merchant");
  };

  //image handler
  const [selectedImage, setSelectedImage] = useState(null);
  const handleImageChange = e => {
    if (e.target.files && e.target.files[0]) {
      const reader = new FileReader();
      reader.onload = event => {
        setSelectedImage(event.target.result);
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  const handleSelectedRow = e => {
    setPDLId(e.id);
    setPDLNumber(e.pdlNumber);
    setFirstName(e.firstName);
    setMiddleName(e.middleName);
    setLastName(e.lastName);
    setGender(e.gender == "M" ? "Male" : "Female");
    setFacilityNumber(e.facilityNumber);
    setOpenPDLList(false);
  };
  const onCategoryChange = e => {
    //console.log(e.target.value);
    setSelectedCat(e.target.value);
  };
  return <div>
      <AlertModal show={showAlert} title="Add Merchant" message={alertMessage} onClose={() => {
      setShowAlert(false);
    }} />
      <PDLList token={getToken && token} isOpen={openPDLList} onClose={() => {
      setOpenPDLList(false);
    }} selectedInfo={handleSelectedRow}></PDLList>
      <Modal className="viewMerchantModal r medium" isOpen={modalIsOpen} onRequestClose={closeSuccessModal}>
        {/* <CloseIcon
          color="black"
          height="25px"
          className="alertCloseButton"
          onClick={closeSuccessModal}
         /> */}
        <div className="flexRow">
          <div style={{
          width: "70px"
        }} className="flexRow">
            <SuccessIcon color="lime" />
          </div>
          <div>
            <p className="xl">Merchant Added!</p>
          </div>
        </div>
      </Modal>

      <p className="xl semibold">Add Merchant</p>
      <div style={{
      height: "10px"
    }}></div>

      <div className="flexRow">
        <p>Enter merchant details and services below:</p>
        <div className="spacer"></div>
        <Button2 style={{
        margin: "5px",
        width: "150px",
        backgroundColor: "#61dd48"
      }} onClick={openSuccessModal} type="submit" text={"Save merchant"}></Button2>
      </div>

      <div style={{
      height: "10px"
    }}></div>

      <div className="line2"></div>

      <div style={{
      height: "10px"
    }}></div>

      <div style={{
      height: "20px"
    }}></div>

      <div className="addMerchantCard">
        <div className="merchantForm">
          <div className="l semibold">
            PDL Information:
          </div>
          <label>
            <div style={{
            marginBottom: 20,
            marginTop: 20
          }}>
                <input type="button" value={"Select a PDL"} onClick={selectPDL} className="btn btn-primary btn-sm" />
            </div>
            <div>
               <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 10
            }}>
                  <div className="bold">PDL Number</div>
                  <div>{pdlNumber}</div>
               </div>
               <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 10
            }}>
                  <div className="bold">First Name</div>
                  <div>{firstName}</div>
               </div>
               <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 10
            }}>
                  <div className="bold">Middle Name</div>
                  <div>{middleName}</div>
               </div>
               <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 10
            }}>
                  <div className="bold">Last Name</div>
                  <div>{lastName}</div>
               </div>
               {/* <div style={{display:'flex',justifyContent:'space-between',marginBottom: 10}}>
                  <div className="bold">Gender</div>
                  <div>{gender}</div>
                </div> */}
               <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: 10
            }}>
                  <div className="bold">Facility Number</div>
                  <div>{facilityNumber}</div>
               </div>
            </div>
          </label>
          <div>
            <strong>With Service Fee</strong>
            <div style={{
            width: 300,
            marginTop: -17,
            marginLeft: 300
          }} className="d-flex justify-content-center align-items-center">
                <select className="form-select" value={withSf} onChange={e => {
              setWithSf(e.target.value);
            }}>
                   <option value={1}>Yes</option>
                   <option value={2}>No</option>
                </select>
            </div>
          </div>

          <div>
            <strong>Merchant Type</strong>
            <div style={{
            width: 300,
            marginTop: -17,
            marginLeft: 300
          }}>
              
              <b>Services</b><input style={{
              marginLeft: 20
            }} type='radio' name="pin" value={"Yes"} onClick={() => {
              setMerchantType('Services');
              setServices([...services, {
                service: "Generic Services",
                amount: 0,
                unit: "service"
              }]);
            }} />
                <br />
                <b>Store</b><input style={{
              marginLeft: 43
            }} type='radio' name="pin" value={"No"} onClick={() => {
              setMerchantType('Store');
              setServices([]);
            }} />
            </div>
          </div>
          
          

        </div>
        <div className="merchantForm">
          <p className="l semibold">Enter Merchant Details:</p>
          <div style={{
          height: "20px"
        }}></div>
          <form onSubmit={handleSubmit}>
            <InputText1 title="Merchant Name" type="text" placeholder="Merchant Name" value={name} onChange={e => setName(e.target.value)} required />
            <InputText1 title="Store Name" type="text" placeholder="Store Name" value={description} onChange={e => setDescription(e.target.value)} required />

            <InputText1 title="Location" type="text" placeholder="Location" value={location} onChange={e => setLocation(e.target.value)} required />
            <div className="w-100">
                <InputText1 title="Store Code" type="text" placeholder="" value={storeCode} readonly={false} onChange={e => {
              setStoreCode(e.target.value);
            }} />
                {storeCodeValidating && <div style={{
              color: '#666',
              fontSize: '12px',
              marginTop: '5px'
            }}>Validating...</div>}
                {storeCodeError && <div style={{
              color: '#d9534f',
              fontSize: '12px',
              marginTop: '5px'
            }}>{storeCodeError}</div>}
                {storeCode && !storeCodeError && !storeCodeValidating && <div style={{
              color: '#5cb85c',
              fontSize: '12px',
              marginTop: '5px'
            }}>✓ Store code is available</div>}
            </div>

            <div className="w-100">
                <Dropdown title={"Store Location"} data={colonies} value={storeLocation} onChange={e => {
              const val = e.target.value;
              setStoreLocation(val);
              // if(val){
              //   const seq = Date.now().toString().slice(-6);
              //   //setStoreCode(`STR-${val}-${seq}`);
              //   let fac = colonies.find(c => c.value == e.target.value)?.fac;
              //   var defaultOption = {
              //     label: '---Select a facility/quadrant---',
              //     value: null
              //   };
              //   //console.log(defaultOption, fac);

              //   setFacilities([defaultOption, ...fac]);
              // } else {
              //   setStoreCode('');
              // }
            }} />
              </div>
            
            {<Dropdown title={"Facility / Quadrant"} data={facilities.map(f => ({
            value: f.FacilityId,
            label: f.Facility
          }))} onChange={e => setQuadrant(e.target.value)} value={quadrant} />}

            {<div className="w-100">
            <InputText1 title={merchantType == 'Services' ? "Kiosk Fee" : merchantType == 'Store' ? "POS Fee" : "Fee"} type="number" value={fee} onChange={e => setFee(e.target.value)} placeholder="Enter Fee" />
          </div>}
            
          </form>

            {merchantType == 'Store' && <div className="merchantForm">
            <p className="l semibold">Add Store Details:</p>
            <div style={{
            height: "20px"
          }}></div>

             <div className="w-100">
              <InputText1 title="POS Username" type="text" value={posUser} onChange={e => setPosUser(e.target.value)} placeholder="Enter POS Username" />
            </div>

            
             <div className="w-100">
              <InputText1 title="POS Password" type="password" value={posPassword} onChange={e => setPosPassword(e.target.value)} placeholder="Enter POS Password" />
            </div>

          </div>}


          {merchantType == 'Services' && <div className="flexRow">
          {options && <Dropdown title={"Category"} data={options} className="r" onChange={onCategoryChange}>
            </Dropdown>}
          </div>}

          

        </div>

        {/* {merchantType == 'Services' && (<div className="merchantForm">
          <p className="l semibold">Add Services Offered:</p>
          <div style={{ height: "20px" }}></div>
            <div className="flexRow">
          {options && <Dropdown
              title={"Category"}
              data = {options}
              className="r"
              onChange={onCategoryChange}
            >
            </Dropdown>}
          </div>
            
          <div className="flexRow">
            <InputText2
              title="Services"
              type="text"
              value={newService}
              onChange={(e) => setNewService(e.target.value)}
              placeholder="Enter a service (Ex. Tech, Food Supply, etc.)"
            />
          </div>
            
          <div>
            <InputText2
              title="Unit"
              type="text"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
              placeholder="Unit"
            />
          </div>
            <div>
            <InputText2
              title="Amount"
              type="number"
              value={serviceAmount}
              onChange={(e) => setServiceAmount(e.target.value)}
              placeholder="0.00"
            />
          </div>
            <div>
            <Button2
              onClick={addService}
              style={{
                margin: "5px",
                width: "150px",
                backgroundColor: "#202020",
              }}
              type="button"
              text={"Add Service"}
            ></Button2>
            <ul>
              {services.map((service, index) => (
                <li key={index}>{service.service} - {"Php " + parseFloat(service.amount).toFixed(2) + " per - " + service.unit}</li>
              ))}
            </ul>
          </div>
         </div>)} */}

        

        
      </div>
    </div>;
};
export default withAuthorization(MerchantPage_Add, 14);